module.exports = "#loader {\n  position: fixed;\n  left: calc(50% + 50px);\n  top: 50%;\n  z-index: 999;\n  margin: -25px 0 0 -25px;\n  border: 5px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 5px solid #3498db;\n  width: 50px;\n  height: 50px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite; }\n  @media (min-width: 0) and (max-width: 767px) {\n    #loader {\n      left: 50%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/loader/loader.scss
// module id = ./src/app/com/loader/loader.scss
// module chunks = main